import {
  RESET_CLIENT_SYSTEM_VALUES,
  RESET_CLIENT_SYSTEM_VALUE,
  RESET_ERROR,
  GET_CLIENT_SYSTEM_VALUES,
  SET_CLIENT_SYSTEM_VALUES,
  API_ERROR,
  CREATE_CLIENT_SYSTEM_VALUE,
  CREATE_CLIENT_SYSTEM_VALUE_SUCCESS,
  GET_CLIENT_SYSTEM_VALUE,
  SET_CLIENT_SYSTEM_VALUE,
  EDIT_CLIENT_SYSTEM_VALUE,
  EDIT_CLIENT_SYSTEM_VALUE_SUCCESS,
  DELETE_CLIENT_SYSTEM_VALUE,
  DELETE_CLIENT_SYSTEM_VALUE_SUCCESS,
} from "./actionTypes";

const initialState = {
  errorClientSystem: false,
  loadingClientSystem: false,
  dataClientSystem: null,
  successClientSystem: false,
};

const ClientSystems = (state = initialState, action) => {
  switch (action.type) {
    case RESET_CLIENT_SYSTEM_VALUES:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystem: false,
        loadingClientSystemDelete: false,
        successClientSystem: false,
        dataClientSystem: null,
        dataClientSystemDelete: null,
      };
      break;
    case RESET_CLIENT_SYSTEM_VALUE:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystem: false,
        successClientSystem: false,
        dataClientSystemGetSet: null,
        dataClientSystemEditCreate: null,
      };
      break;
    case RESET_ERROR:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystem: false,
        loadingClientSystemEditCreate: false,
        loadingClientSystemActivate: false,
        successClientSystem: false,
      };
      break;
    case GET_CLIENT_SYSTEM_VALUES:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystem: true,
        dataClientSystem: null,
      };
      break;
    case SET_CLIENT_SYSTEM_VALUES:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystem: false,
        dataClientSystem: action.payload,
      };
      break;
    case CREATE_CLIENT_SYSTEM_VALUE:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystemEditCreate: true,
        dataClientSystemEditCreate: action.payload,
        successClientSystem: false,
      };
      break;
    case CREATE_CLIENT_SYSTEM_VALUE_SUCCESS:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystemEditCreate: false,
        dataClientSystemEditCreate: action.payload,
        successClientSystem: true,
      };
      break;
    case GET_CLIENT_SYSTEM_VALUE:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystem: true,
        dataClientSystemGetSet: null,
      };
      break;
    case SET_CLIENT_SYSTEM_VALUE:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystem: false,
        dataClientSystemGetSet: action.payload,
      };
      break;
    case EDIT_CLIENT_SYSTEM_VALUE:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystemEditCreate: true,
        dataClientSystemEditCreate: action.payload,
        successClientSystem: false,
      };
      break;
    case EDIT_CLIENT_SYSTEM_VALUE_SUCCESS:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystemEditCreate: false,
        dataClientSystemEditCreate: action.payload,
        successClientSystem: true,
      };
      break;
    case API_ERROR:
      state = {
        ...state,
        errorClientSystem: action.payload,
        loadingClientSystem: false,
        loadingClientSystemDelete: false,
        successClientSystem: false,
      };
      break;
    case DELETE_CLIENT_SYSTEM_VALUE:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystemDelete: true,
        dataClientSystemDelete: action.payload,
        successClientSystem: false,
      };
      break;
    case DELETE_CLIENT_SYSTEM_VALUE_SUCCESS:
      state = {
        ...state,
        errorClientSystem: false,
        loadingClientSystemDelete: false,
        dataClientSystemDelete: action.payload,
        successClientSystem: true,
      };
      break;
    default:
      // state = { ...state, errorClientSystem: false, loadingClientSystem: false };
      break;
  }
  return state;
};

export default ClientSystems;
